import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION9: PdfComponent = {
  type: 'section',
  id: 'iars9',
  title: '9. Variations',
  content: [
    {
      type: 'bulletList',
      id: 'iars9bullets',
      bulletType: 'number',
      content: [
        {
          copy: {
            type: 'altText',
            id: 'iar91',
            content: [
              'The Principal may vary this Agreement with ',
              "3 months' notice",
              '.',
            ],
            boldFirst: false,
          },
        },
        {
          copy: {
            type: 'altText',
            id: 'iar92',
            content: [
              'The Introducer may terminate the Agreement with ',
              "1 month's notice",
              ' if it does not accept the variation.',
            ],
            boldFirst: false,
          },
        },
      ],
      prefix: '9',
    },
  ],
};
